import { FC } from "react"

import { css, Theme } from "@emotion/react"
import { Dialog, DialogContent } from "@material-ui/core"
import { Button } from "@ncs/web-legos"

export interface SupportIssueModalProps {
	isOpen?: boolean
	onClose: () => void
}

export const SupportIssueModal: FC<SupportIssueModalProps> = ({ isOpen = true, onClose }) => {
	return (
		<Dialog
			open={isOpen}
			onClose={onClose}
			maxWidth="sm"
			fullWidth
			fullScreen={false}
			css={dialogStyles}
		>
			<DialogContent css={contentStyles}>
				<h2 css={titleStyles}>Contact Customer Service</h2>
				<p css={subtitleStyles}>If you're experiencing difficulties, please reach out.</p>

				<div css={columnsContainerStyles}>
					<div css={columnStyles}>
						<h3 css={columnTitleStyles}>Part Orders</h3>
						<a href="mailto:parts@ncswash.com" css={linkStyles}>
							parts@ncswash.com
						</a>
						<a href="tel:1-844-593-8549" css={linkStyles}>
							1-844-593-8549
						</a>
					</div>

					<div css={columnStyles}>
						<h3 css={columnTitleStyles}>Chemical &amp; Detail Orders</h3>
						<a href="mailto:vc-customerservice@ncswash.com" css={linkStyles}>
							vc-customerservice@ncswash.com
						</a>
						<a href="tel:1-844-593-8549" css={linkStyles}>
							1-844-593-8549
						</a>
					</div>
				</div>

				<Button
					variant="primary-cta"
					onClick={onClose}
					fillContainer
					css={closeButtonStyles}
				>
					CLOSE
				</Button>
			</DialogContent>
		</Dialog>
	)
}

const dialogStyles = css`
	.MuiDialog-paper {
		border-radius: 0.75rem;
		padding: 2rem;
		max-height: calc(100% - 3rem);
		box-sizing: border-box;

		@media (max-width: 600px) {
			padding: 0.5rem;
		}
	}
`

const contentStyles = css`
	text-align: center;
	padding: 1rem !important;
`

const titleStyles = (theme: Theme) => css`
	font-size: 2rem;
	font-weight: bold;
	margin: 0 0 0.5rem 0;
	color: ${theme.palette.colors.gray900};
`

const subtitleStyles = (theme: Theme) => css`
	font-size: 1rem;
	color: ${theme.palette.colors.gray600};
	margin: 0 0 3rem 0;
	font-weight: 500;
	@media (max-width: 600px) {
		margin: 0 0 2rem 0;
	}
`

const columnsContainerStyles = css`
	display: grid;
	grid-template-columns: 200px 1fr;
	gap: 0;
	text-align: left;
	margin-bottom: 3rem;

	@media (max-width: 600px) {
		grid-template-columns: 1fr;
		gap: 2rem;
		margin-bottom: 2rem;
	}
`

const columnStyles = css`
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
`

const columnTitleStyles = (theme: Theme) => css`
	font-size: 1rem;
	font-weight: bold;
	margin: 0 0 0.5rem 0;
	color: ${theme.palette.colors.gray900};
`

const linkStyles = (theme: Theme) => css`
	color: ${theme.palette.colors.brandCobalt};
	text-decoration: none;
	font-size: 0.95rem;

	&:hover {
		text-decoration: underline;
		color: ${theme.palette.colors.brandDeepNavy};
	}
`

const closeButtonStyles = css`
	border-radius: 0.5rem;
`
